import $ from 'jquery'
import { closeModal, convertDateToDdMmYyyy } from '@/function/function.js';
import Vue from 'vue';
import VueHtml2pdf from 'vue-html2pdf'

Vue.use(VueHtml2pdf)

export default {
    name: 'caisse-ouverture',
    components: {},
    props: [],
    data() {
        return {
            user_role: 0,
            compte_id: 0,
            user_id: 0,

            loading: false,
            d_solde_cloture: 0, //  Dernier solde de cloture representant le solde théorique à une date t
            montant_total: 0, //  Montant controllé
            erreur_caisse: 0,
            date_ouverture: '',

            argent: [10000, 5000, 2000, 1000, 500],
            argent_piece: [500, 250, 100, 50, 25, 10, 1],

            total_piece: 0,
            total_billet: 0,

            billets: [{
                "billet_nb": '',
                "billet_total": '',
            }],

            pieces: [{
                "piece_nb": '',
                "piece_total": '',
            }],
            billet_argents: ['10 000', '5 000', '2 000', '1 000', '500'],

            piece_argents: ['500', '250', '100', '50', '25', '10', '1'],
        }
    },
    computed: {
        /**
         * User Info
         * @returns 
         */
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        activeRole(){
            return this.$store.getters['activeRole'];
        },

        /**
         * Recupère le dernier solde de cloture de la caisse en instance 
         * d'être ouverte
         * @returns 
         */
        dernier_solde_cloture() {
            return this.$store.getters['dernier_solde_cloture', this.compte_id];
        },
    },
    mounted() {
        setTimeout(() => {
            $('.p-content').fadeIn();
        }, 500);

        if (this.userCredentials.user.roles.length > 0) {
            this.user_id = this.userCredentials.user.id
            this.user_role = this.userCredentials.user.roles[0].nom;

            if(this.activeRole.nom == 'ROLE_CAISSIERE') {
                this.compte_id = 1      //  Caisse principale
            } else if (this.activeRole.nom == 'ROLE_CAISSIERE_INTERMITENT') {
                this.compte_id = 4      //  Caisse 1 (Infirmier)
            } else if (this.activeRole.nom == 'ROLE_COMPTABLE') {
                this.compte_id = 3      //  Comptabilité
            }
        }

        for (let i = 1; i <= 5; i++) {
            this.billets.push({ billet_nb: '', billet_total: '' });
        }

        for (let i = 1; i <= 7; i++) {
            this.pieces.push({ piece_nb: '', piece_total: '' });
        }

        console.log("COMPTE OUVERTURE: ",this.compte_id, " --> ",this.activeRole.nom)

        // >>>> Dernier solde de cloture d'une caisse
        this.$store.dispatch('getDernierSoldeCloture', this.compte_id).then((response) => {
            this.d_solde_cloture = response;
            this.date_ouverture = convertDateToDdMmYyyy.convertDate(new Date());
        });
    },
    methods: {
        formatNumbers(num) {
            return new Number(num).toLocaleString("fr-FR");
        },

        /**
         * 
         * @param {*} selector 
         * @param {*} index 
         */
        async calculArgent(selector, index) {
            this.montant_total = 0;



            if (selector == 'billet') {
                this.total_billet = 0;
                this.billets[index].billet_total = this.billets[index].billet_nb * this.argent[index];


                for (let i = 0; i < 5; i++) {
                    this.billets[i].billet_total = (this.billets[i].billet_total == '') ? 0 : this.billets[i].billet_total;
                    this.total_billet += this.billets[i].billet_total;
                }

            } else {
                this.total_piece = 0;

                this.pieces[index].piece_total = this.pieces[index].piece_nb * this.argent_piece[index];


                for (let i = 0; i < 7; i++) {
                    this.pieces[i].piece_total = (this.pieces[i].piece_total == '') ? 0 : this.pieces[i].piece_total;
                    this.total_piece += this.pieces[i].piece_total;
                }
            }
            this.montant_total = this.total_billet + this.total_piece;
            this.erreur_caisse = this.montant_total - this.d_solde_cloture;
        },

        calcErreurCaisse() 
        {
            console.log("ERREUR CAISSE: ",this.montant_total," - ",this.d_solde_cloture)
            this.erreur_caisse = this.montant_total - this.d_solde_cloture;
        },

        async ouvrirCaisse() {
            $('.err-role').fadeOut(500)
            this.loading = true;
            let err = 0
            let data = [],
                controle_billet = []

            // RECAP CONTROLE DES BILLETS 
            for (let bx = 0; bx < this.billet_argents.length; bx++) {
                let nb = (this.billets[bx].billet_nb != '') ? this.billets[bx].billet_nb : 0
                let b = this.billet_argents[bx]
                let contorle = 'b' + '-' + nb + '-' + b

                controle_billet.push(
                    contorle
                )
            }
            // RECAP CONTROLE DES PIECES
            for (let bx = 0; bx < this.piece_argents.length; bx++) {
                let nb = (this.pieces[bx].piece_nb != '') ? this.pieces[bx].piece_nb : 0
                let b = this.piece_argents[bx]
                let contorle = 'p' + '-' + nb + '-' + b
                controle_billet.push(
                    contorle
                )
            }
            this.erreur_caisse = this.montant_total - this.d_solde_cloture;

            let commentaire = $('#txtArea').html();

            data.push({
                "compte_id": this.compte_id,
                "user_id": this.user_id,
                "date_ouverture": Date(),
                "commentaire": commentaire,
                "solde_ouverture": this.montant_total,
                "erreur_caisse": this.erreur_caisse,
                "controle_ouverture": controle_billet
            })

            if (this.compte_id == 0) {
                err++
                this.loading = false;
                $('.err-role').fadeIn(500)
            }

            if (err == 0) {
                this.$store.dispatch('openCaisse', data).then(
                    (response) => {
                        if (response == -2) {
                            // Caisse non ouvrable
                            this.loading = false;
                            $('.err-ouverture').fadeIn()
                        } else {
                            this.loading = false;
                            $('.modal').modal('hide')
                            this.$router.push({ path: '/clinicaa/comptabilite/caisse' })
                        }

                    }
                ).catch(
                    error => {
                        this.loading = false;
                        console.log(error);
                    }

                )
            }
        },

        /**
         * Close Modal
         * @param {*} selector 
         */
        closeModal(selector) {
            closeModal.closeModal(selector);
        },

        /**
         * Imprimer le rapport de versement
         */
        printRapport() {
            this.$refs.html2Pdf.generatePdf()
        },
    }
}